var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medication"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15 9.17627C15 12.49 12.3137 15.1763 9 15.1763C5.68629 15.1763 3 12.49 3 9.17627C3 5.86256 5.68629 3.17627 9 3.17627C12.3137 3.17627 15 5.86256 15 9.17627Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0586 10.7035C18.2773 10.4848 18.2473 10.1206 17.979 9.96686C17.1012 9.46384 16.0842 9.17627 15 9.17627C11.6863 9.17627 9 11.8626 9 15.1763C9 16.2605 9.28757 17.2775 9.79059 18.1553C9.94436 18.4236 10.3085 18.4535 10.5272 18.2348L18.0586 10.7035ZM20.2094 12.1973C20.0556 11.929 19.6915 11.899 19.4728 12.1177L11.9414 19.6491C11.7227 19.8677 11.7527 20.2319 12.021 20.3857C12.8988 20.8887 13.9158 21.1763 15 21.1763C18.3137 21.1763 21 18.49 21 15.1763C21 14.0921 20.7124 13.075 20.2094 12.1973Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/Medication.c5fc805ca4d248dfd697ca7644c72a7e.svg";
export { ForwardRef as ReactComponent };